var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgGoogleColorfull(props) {
  const _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: `url(#${_id})`
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.024 12.655c0-.818-.07-1.634-.211-2.44H12.255v4.621h6.62a5.488 5.488 0 01-.843 2.069 5.615 5.615 0 01-1.605 1.578v3h3.95c2.314-2.088 3.647-5.177 3.647-8.828z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.255 24.381c3.308 0 6.092-1.063 8.123-2.896l-3.95-3c-1.1.73-2.517 1.146-4.173 1.146-3.196 0-5.91-2.11-6.88-4.953h-4.07v3.092a12.099 12.099 0 004.518 4.825 12.45 12.45 0 006.432 1.786z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.375 14.678a7.048 7.048 0 010-4.593V6.993h-4.07a11.797 11.797 0 00-1.304 5.388c0 1.871.447 3.717 1.305 5.389l4.07-3.092z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.255 5.131a6.732 6.732 0 014.702 1.8l3.497-3.425A11.915 11.915 0 0012.255.381a12.45 12.45 0 00-6.432 1.786 12.098 12.098 0 00-4.517 4.826l4.07 3.092c.97-2.844 3.683-4.954 6.88-4.954z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .381)",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgGoogleColorfull;